import gql from 'graphql-tag';

export const buildItemQuery = (
  id: string,
  lang = 'en-US',
  fragName: string,
  fragContent: string
) => {
  return gql`query {
    item(path:"${id}", language:"${lang}") {
      id
      name
      displayName
      ...${fragName}
    }
  }
  ${fragContent}`;
};
export const getItemQuery = (path: string, lang = 'en-US') => {
  return gql`query {
  item(path: "${path}", language:"${lang}") {
    id
    name
    displayName
    allFields: fields(ownFields: true) {
      name
      value
    }
  }}`;
};
